import { validateEnumTranslations } from '../../safety_checks';

export enum PageTypeEnum {
  HOME = 'home',
  ABOUT = 'about',
  SERVICES = 'services',
  CONTACT = 'contact',
  BLOG = 'blog',
  GIFT = 'gift',
  PACK = 'pack',
  BOOKING = 'booking',
  CUSTOM = 'custom',
  PLACES = 'places',
  COOKIE_POLICY = 'cookie-policy',
  PRIVACY_POLICY = 'privacy-policy',
  LEGAL_NOTICES = 'legal-notices',
  EXTERNAL_LINK = 'external-link',
}

export const PageTypeTranslation = {
  'fr-FR': {
    [`${PageTypeEnum.HOME}`]: 'Accueil',
    [`${PageTypeEnum.ABOUT}`]: 'A propos',
    [`${PageTypeEnum.SERVICES}`]: 'Prestations',
    [`${PageTypeEnum.CONTACT}`]: 'Contact',
    [`${PageTypeEnum.BLOG}`]: 'Blog',
    [`${PageTypeEnum.GIFT}`]: 'Cartes cadeaux',
    [`${PageTypeEnum.PACK}`]: 'Packs',
    [`${PageTypeEnum.BOOKING}`]: 'Réservation',
    [`${PageTypeEnum.CUSTOM}`]: 'Page vierge',
    [`${PageTypeEnum.PLACES}`]: 'Lieux',
    [`${PageTypeEnum.COOKIE_POLICY}`]: 'Politique des cookies',
    [`${PageTypeEnum.PRIVACY_POLICY}`]: 'Politique de confidentialité',
    [`${PageTypeEnum.LEGAL_NOTICES}`]: 'Mentions légales',
    [`${PageTypeEnum.EXTERNAL_LINK}`]: 'Lien externe',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(PageTypeEnum, PageTypeTranslation, '', true);
